import "./VirtualGallery.css";
import galleryImg from "./assets/images/vr.webp";

function VirtualGallery() {
  return (
    <section className="virtual-gallery">

      <img
        src={galleryImg}
        alt="Virtual Gallery"
        className="gallery-image"
      />
      <a
        href="https://www.artoreal.com/3d-virtual-gallery"
        target="_blank"
        rel="noopener noreferrer"
      >
      <button className="gallery-btn">
        Experience Virtual Gallery
      </button>
      </a>
    </section>
  );
}

export default VirtualGallery;